import styled from 'styled-components';
import { device } from '@/styles/helpers';

export const ScLevelCard = styled.div<{
  $glowColor: string;
  $glowEndOpacity: number;
}>`
  position: relative;
  width: 132px;
  height: 233px;
  flex-shrink: 0;
  cursor: pointer;

  @media (${device.mobile}) {
    width: 100%;
  }

  &.locked {
    cursor: default;
  }

  &.selected::before {
    content: '';
    position: absolute;
    z-index: 0;
    top: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: 112px;
    height: 167px;
    background: ${({ $glowColor, $glowEndOpacity }) => `linear-gradient(
      180deg,
      rgba(${$glowColor}, 0) 0%,
      rgba(${$glowColor}, ${$glowEndOpacity}) 100%
    )`};
    filter: blur(22px);
    pointer-events: none;
  }

  img {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    right: 0;
    width: 100%;
    height: 100%;
    max-height: 201px;
    object-fit: contain;
    max-width: 116px;
    object-position: bottom;
    transition: filter 0.2s ease;
  }

  &.locked img,
  &.done img,
  &.canceled img {
    opacity: 0.7;
  }

  &.last img {
    max-width: 103px;
    object-fit: cover;
  }

  .cardClaimBtn {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    width: 116px;
    margin: 0 auto;
    height: 32px;
    bottom: 4px;
    transform: translateY(-12px);
    border: none;
    border-radius: 360px;
    background: #25aad6;
    color: ${({ theme }) => theme.whiteColor};
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.14px;
    text-transform: uppercase;
    cursor: pointer;
  }
`;
